import React from 'react';
import '../styles/Footer.css';
import { Phone, Mail, LocateIcon, Youtube, Instagram, Facebook } from 'lucide-react';
import logo from "../assets/image0.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ftr-footer">
      <div className="ftr-content">

        {/* Logo Section */}
        <div className="ftr-logo-section">
          <img src={logo} alt="Seth G.L. Bihani Logo" className="ftr-logo-img" />
          <p className="ftr-school-name">Seth G.L. Bihani</p>
          <p className="ftr-school-sub">S.D. SR. SEC. SCHOOL</p>
          <p className="ftr-school-tagline">Excellence in Education</p>
        </div>

        {/* Quick Links */}
        <div className="ftr-section">
          <h3 className="ftr-section-title">Quick Links</h3>
          <div className="ftr-links">
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/laboratory">Facilities</a>
            <a href="/gallery">Gallery</a>
            <a href="/admission">Admission</a>
            <a href="/sister">Sister Concern</a>
          </div>
        </div>

        {/* Contact Info */}
        <div className="ftr-section">
          <h3 className="ftr-section-title">Contact Info</h3>
          <div className="ftr-contact">
            <div className="ftr-contact-item">
              <div className="ftr-contact-icon"><Phone size={15} /></div>
              <div className="ftr-contact-text">
                <a href="tel:+01542466778">+01542466778</a>
              </div>
            </div>
            <div className="ftr-contact-item">
              <div className="ftr-contact-icon"><Mail size={15} /></div>
              <div className="ftr-contact-text">
                <a href="mailto:bihanischool@yahoo.in">bihanischool@yahoo.in</a>
              </div>
            </div>
            <div className="ftr-contact-item">
              <div className="ftr-contact-icon"><LocateIcon size={15} /></div>
              <div className="ftr-contact-text">
                <p>National Highway 62, Near Sukhadiya Circle, Sri Ganganagar</p>
              </div>
            </div>
          </div>
        </div>

        {/* Follow Us */}
        <div className="ftr-section">
          <h3 className="ftr-section-title">Follow Us</h3>
          <p className="ftr-social-desc">Connect with us on social media</p>
          <div className="ftr-social-row">
            <a href="https://www.facebook.com/sdbihanischoolsgnr/" className="ftr-social-btn" title="Facebook" target="_blank" rel="noopener noreferrer">
              <Facebook size={16} />
            </a>
            <a href="https://www.instagram.com/sdbihanischoolsgnr/" className="ftr-social-btn" title="Instagram" target="_blank" rel="noopener noreferrer">
              <Instagram size={16} />
            </a>
            <a href="https://www.youtube.com/@Bihanishikshatrustsgnr" className="ftr-social-btn" title="YouTube" target="_blank" rel="noopener noreferrer">
              <Youtube size={16} />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="ftr-bottom">
        <p>
          Copyright © {currentYear} Seth G.L. Bihani S.D Sr. Sec. School.
          All rights reserved. Design and Developed by NISHANT AND TARUN SARASWAT
        </p>
      </div>
    </footer>
  );
};

export default Footer;